import { render, staticRenderFns } from "./AcademyMajorCreate.vue?vue&type=template&id=d9f01438&scoped=true&"
import script from "./AcademyMajorCreate.vue?vue&type=script&lang=js&"
export * from "./AcademyMajorCreate.vue?vue&type=script&lang=js&"
import style0 from "./AcademyMajorCreate.vue?vue&type=style&index=0&id=d9f01438&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f01438",
  null
  
)

export default component.exports